import { Modal } from 'bootstrap';

declare const _urlSvodAddFilm: string;
declare const UVII: {
    localServerFound: boolean;
    launchDeeplink: (url: string) => void;
};
declare function getDeeplinkAuthParams(): string;
declare function growl_message(msg: string): void;

function getUrlAddSvodFilm(videoProductionId: string | number): string {
    return _urlSvodAddFilm.replace('-id-', String(videoProductionId));
}

document.addEventListener('DOMContentLoaded', () => {

    /* ---------- Add movie ---------- */
    document.querySelectorAll<HTMLButtonElement>('.btnAddMovie')
        .forEach(btn => {
            btn.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault();

                const { productid, link } = btn.dataset;
                if (!productid || !link) return;

                fetch(getUrlAddSvodFilm(productid))
                    .then(res => res.json() as Promise<{
                        message?: string;
                        userSvodProductId: string;
                    }>)
                    .then(result => {
                        if (!result.message) return;

                        if (UVII.localServerFound === false) {
                            document
                                .querySelectorAll<HTMLElement>('.modal-content-checkout, .overlay')
                                .forEach(el => (el.style.display = 'none'));

                            const modalEl = document.querySelector<HTMLElement>('#splashDownloadModal1');
                            if (modalEl) {
                                const modal = Modal.getInstance(modalEl) ?? new Modal(modalEl);
                                modal.show();
                            }
                        } else {
                            UVII.launchDeeplink(
                                link + result.userSvodProductId + getDeeplinkAuthParams()
                            );
                        }
                    });
            });
        });

    /* ---------- Modal / overlay helpers ---------- */
    const toggleDisplay = (selector: string, display: 'block' | 'none'): void => {
        document.querySelectorAll<HTMLElement>(selector)
            .forEach(el => (el.style.display = display));
    };

    document.querySelectorAll<HTMLElement>('.btnWatchSvod')
        .forEach(btn => {
            btn.addEventListener('click', () => {
                const modalEl = document.querySelector<HTMLElement>('.svod-edito-modal');
                if (modalEl) {
                    const modal = Modal.getInstance(modalEl) ?? new Modal(modalEl);
                    modal.hide();
                }
            });
        });

    document.querySelectorAll<HTMLElement>('.js-trigger-overlay-svod')
        .forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                toggleDisplay('.overlay__container', 'block');
            });
        });

    document.querySelectorAll<HTMLElement>('.overlay-svod__close')
        .forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                toggleDisplay('.overlay__container', 'none');
            });
        });

    document.querySelectorAll<HTMLElement>('.js-trigger-overlay-svod-keep')
        .forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                toggleDisplay('.overlay__container_keep', 'block');
            });
        });

    document.querySelectorAll<HTMLElement>('.overlay-svod-keep__close')
        .forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                toggleDisplay('.overlay__container_keep', 'none');
            });
        });

    /* ---------- Film history ---------- */
    const historyWrapper =
        document.querySelector<HTMLElement>('#list-user-films.history-wrapper');

    if (historyWrapper) {
        historyWrapper.addEventListener('click', e => {
            const target = e.target as HTMLElement;

            if (!target.matches('.js-delete-film-history')) return;
            e.preventDefault();

            const { url, id } = target.dataset;
            if (!url || !id) return;

            const filmIcon =
                document.querySelector<HTMLElement>(`li[data-id="${id}"]`);

            ajaxDeleteFilmHistory(url, filmIcon);
        });
    }

    function ajaxDeleteFilmHistory(
        url: string,
        filmIcon: HTMLElement | null
    ): void {
        fetch(url, {
            method: 'DELETE',
            headers: { Accept: 'application/json' }
        })
            .then(res => res.json() as Promise<{ status: string; message: string }>)
            .then(data => {
                growl_message(data.message);
                if (data.status === 'ok' && filmIcon) {
                    filmIcon.remove();
                }
            });
    }

    /* ---------- Switch renew ---------- */
    function ajaxSwitchRenew(
        blocParent: HTMLElement,
        url: string
    ): void {
        fetch(url)
            .then(res => res.json() as Promise<{ data: { isToRenew: string } }>)
            .then(result => {
                blocParent.className =
                    result.data.isToRenew === '1'
                        ? 'isToRenew'
                        : 'isNotToRenew';
            });
    }

    document.querySelectorAll<HTMLAnchorElement>('.linkSwitchSubscribe')
        .forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const blocParent = link.parentElement?.parentElement;
                const href = link.getAttribute('href');

                if (blocParent && href) {
                    ajaxSwitchRenew(blocParent, href);
                }
            });
        });

    function createModalFromBodyHtml(
        bodyHtml: string,
        options?: {
            title?: string;
            size?: 'sm' | 'lg' | 'xl';
            scrollable?: boolean;
            centered?: boolean;
        }
    ): bootstrap.Modal {
        const modalEl = document.createElement('div');
        modalEl.className = 'modal fade';
        modalEl.tabIndex = -1;
        modalEl.setAttribute('aria-hidden', 'true');

        const sizeClass = options?.size ? `modal-${options.size}` : '';
        const scrollableClass = options?.scrollable ? 'modal-dialog-scrollable' : '';
        const centeredClass = options?.centered ? 'modal-dialog-centered' : '';

        modalEl.innerHTML = `
        <div class="modal-dialog ${sizeClass} ${scrollableClass} ${centeredClass}">
            <div class="modal-content">
                <button type="button" style="position: absolute;right: 20px;top: 18px;" data-dismiss="modal">
                    <svg style="cursor: pointer;transform: rotate(45deg)" xmlns="http://www.w3.org/2000/svg" version="1.1" width="25" height="25" viewBox="0 0 25 25">
                      <defs>
                        <style>
                          .st0 {
                            fill: none;
                            stroke: #fff;
                            stroke-linecap: round;
                            stroke-width: 4px;
                          }
                        </style>
                      </defs>
                      <path class="st0" d="M12.5,1.2v22.5"></path>
                      <path class="st0" d="M23.8,12.5H1.2"></path>
                    </svg>
                  </button>
                <div class="modal-body">
                    ${bodyHtml}
                </div>
            </div>
        </div>
    `;

        document.body.appendChild(modalEl);

        const modal = new Modal(modalEl);

        // Cleanup when closed
        modalEl.addEventListener('hidden.bs.modal', () => {
            modal.dispose();
            modalEl.remove();
        });

        return modal;
    }

    /* ---------- Watch film (edito) ---------- */
    document.querySelectorAll<HTMLElement>('.watch-film-btn-edito')
        .forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelector('.modal-backdrop')?.remove();

                const currentPath = btn.dataset.currentpath;

                optionFilm('watch', currentPath).then(response => {
                    createModalFromBodyHtml(response.html).show();
                    // new Modal(response).showModal();
                });
            });
        });

    /* ---------- Option film ---------- */
    interface OptionFilmResponse {
        // Adjust if you know the exact structure
        html?: string;
        [key: string]: any;
    }

    const optionFilm = async (
        type: string,
        currentPath?: string
    ): Promise<OptionFilmResponse> => {
        const loc = window.location;
        const port =
            loc.port && loc.port !== '80' ? `:${loc.port}` : '';

        let requestUrl =
            `${loc.protocol}//${loc.hostname}${port}${loc.pathname}/product/${type}`;

        if (currentPath) {
            requestUrl = `${currentPath}/product/${type}`;
        }

        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json, text/html'
            },
            credentials: 'same-origin'
        });

        if (!response.ok) {
            throw new Error(`optionFilm failed (${response.status})`);
        }

        // If your backend returns HTML
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            return response.json();
        }

        return { html: await response.text() };
    };

    /* ---------- Transactions ---------- */
    const transactionsWrapper =
        document.querySelector<HTMLElement>('.transactions-wrapper');

    if (transactionsWrapper) {
        transactionsWrapper.addEventListener('click', e => {
            const link =
                (e.target as HTMLElement).closest<HTMLAnchorElement>(
                    '.transaction-item-link'
                );

            if (!link) return;
            e.preventDefault();

            const confirmMsg = link.dataset.confirm;
            const url = link.dataset.url;

            if (!url || !confirmMsg) return;
            if (!confirm(confirmMsg)) return;

            fetch(url, { method: 'DELETE' })
                .then(res => res.json() as Promise<{ status: string; message: string }>)
                .then(data => {
                    growl_message(data.message);
                    if (data.status === 'ok') {
                        link.closest('.row-user-transactions')?.remove();
                    }
                });
        });
    }

    /* ---------- Subscription change ---------- */
    let offerSelected: HTMLElement | null = null;

    const changeButton =
        document.querySelector<HTMLElement>(
            '.mySpaceSvodSubscription .svodChange .change-offer-button'
        );

    const extendButton =
        document.querySelector<HTMLElement>(
            '.mySpaceSvodSubscription .svodChange .extend-offer-button'
        );

    const extendPossible =
        extendButton?.dataset.extendPossible === 'true';

    document
        .querySelectorAll<HTMLElement>(
            '.mySpaceSvodSubscription .svodChange .offer'
        )
        .forEach(offer => {
            offer.addEventListener('click', e => {
                e.preventDefault();
                offerSelected = offer;

                const actualOffer =
                    document.querySelector<HTMLElement>(
                        '.mySpaceSvodSubscription .svodChange .actual-offer'
                    );

                const isActualOffer = offer === actualOffer;

                document.querySelectorAll('.offer')
                    .forEach(o => o.classList.remove('offer-selected'));

                offer.classList.add('offer-selected');

                if (changeButton) {
                    changeButton.style.display =
                        isActualOffer ? 'none' : 'inline-block';
                }

                if (extendButton) {
                    extendButton.style.display =
                        isActualOffer && extendPossible
                            ? 'inline-block'
                            : 'none';
                }

                if (!isActualOffer) {
                    document.querySelector<HTMLElement>(
                        '.change-svod-modal .svod-product-summary'
                    )!.textContent = offer.dataset.summary ?? '';

                    document.querySelector<HTMLElement>(
                        '.change-svod-modal .changeInformationText'
                    )!.textContent = offer.dataset.changeInformation ?? '';

                    document.querySelector<HTMLAnchorElement>(
                        '.change-svod-modal .accept-change-offer'
                    )?.setAttribute('href', offer.dataset.changePath ?? '');

                    document.querySelector<HTMLElement>(
                        '#modal-change-inprogress .has-change-inprogress'
                    )!.textContent =
                        offer.dataset.hasChangeInprogress ?? '';
                }
            });
        });

    document
        .querySelector<HTMLElement>(
            '.mySpaceSvodSubscription #change-offer .change-offer-button'
        )
        ?.addEventListener('click', e => {
            e.preventDefault();
            if (!offerSelected) return;

            const hasChange = offerSelected.dataset.hasChangeInprogress;

            if (hasChange && hasChange.length > 0) {
                const modalEl = document.querySelector<HTMLElement>('#modal-change-inprogress');
                if (modalEl) {
                    const modal = Modal.getInstance(modalEl) ?? new Modal(modalEl);
                    modal.show();
                }
            } else {
                document.querySelector<HTMLElement>(
                    '.change-svod-modal'
                )!.style.display = 'block';
            }
        });

    document
        .querySelectorAll<HTMLAnchorElement>(
            '.change-svod-modal .svod-keep-no a.btn'
        )
        .forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                document.querySelector<HTMLElement>(
                    '.change-svod-modal'
                )!.style.display = 'none';
            });
        });
});
